import { t } from "@/i18n-js/instance";
import { FormTipTapEditor } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/RichTextField/FormTiptapEditor";
import { Form } from "@circle-react-uikit/Form";
import { LinkInput } from "@circle-react-uikit/Form/LinkInput";

const labelClassName = "!font-normal text-xs";

export const ContentEditor = () => (
  <div className="px-6">
    <Form.Item
      name="text"
      label={t("builder_ui.prop_type.text")}
      hideBorder
      hideDescription
      labelClassName={labelClassName}
    >
      <FormTipTapEditor name="text" />
    </Form.Item>
    <Form.Item
      name="href"
      label={t("builder_ui.prop_type.link")}
      hideBorder
      hideDescription
      labelClassName={labelClassName}
    >
      <LinkInput name="href" />
    </Form.Item>
  </div>
);
